(() => {
  const STORAGE_KEY = "collection-grid-view";
  const ROOT = "collection-component.collection-grid";
  const TOGGLE = "[data-collection-grid-view]";
  const BUTTON = "[data-grid-view]";
  const ACTIVE = "is-active";

  function normalizeColumns(columns) {
    const value = String(columns);
    if (value === "2") return "2";
    if (value === "4") return "4";
    return "4";
  }

  function applyView(root, columns) {
    const value = normalizeColumns(columns);

    root.setAttribute("data-view", value);
    // Inline custom properties beat the section #id style block
    root.style.setProperty("--COLUMNS", value);
    root.style.setProperty("--COLUMNS-MEDIUM", value === "2" ? "2" : value === "4" ? "3" : "2");

    root.querySelectorAll(BUTTON).forEach((button) => {
      const isActive = button.getAttribute("data-grid-view") === value;
      button.classList.toggle(ACTIVE, isActive);
      button.setAttribute("aria-pressed", isActive ? "true" : "false");
    });

    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {
      // Ignore storage errors
    }
  }

  function init(root) {
    if (!root || root.dataset.viewBound === "true") return;
    root.dataset.viewBound = "true";

    const toggle = root.querySelector(TOGGLE);
    if (!toggle) return;

    let saved = root.getAttribute("data-view") || "4";
    try {
      saved = window.localStorage.getItem(STORAGE_KEY) || saved;
    } catch (e) {
      // keep attribute default
    }

    // Migrate old 3-column preference to the new 4-column default
    if (saved === "3") saved = "4";

    applyView(root, saved);

    toggle.addEventListener("click", (event) => {
      const button = event.target.closest(BUTTON);
      if (!button || !root.contains(button)) return;
      event.preventDefault();
      applyView(root, button.getAttribute("data-grid-view"));
    });
  }

  function initAll() {
    document.querySelectorAll(ROOT).forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    const section = event.target;
    const root =
      section?.querySelector?.(ROOT) ||
      (section?.matches?.(ROOT) ? section : null);
    if (root) {
      delete root.dataset.viewBound;
      init(root);
    }
  });
})();
